/**
* Function creates full HTTP path
* @param ivaWebUrl - IVA public url
* @param resourceName - Name of the resource with extension, if resource within subdirectory include partial path like static/js/test.png or test.png
*/
export function createResourceUrl(ivaWebUrl, resourceName) {
    return ivaWebUrl.length > 1 ? `${ivaWebUrl}/${resourceName}` : resourceName;
}
export async function getResource(ivaWebUrl, textResourcePath) {
    const url = createResourceUrl(ivaWebUrl, textResourcePath);
    const changeLogResonse = await fetch(url);
    return changeLogResonse.text();
}
export function isTestPage(ivaWebUrl) {
    return ivaWebUrl.length <= 1 || ivaWebUrl.indexOf(window.location.origin) === 0;
}
